
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { Table } from "reactstrap";
import { GetWorkorderList } from "action/workorderAction";
import styles from './table.module.css';
import progressindicator from 'Assets/images/ProgressIndicator.gif';

//Pagination
import Pagination from 'rc-pagination';
import localeInfo from 'rc-pagination/lib/locale/en_US';
import 'rc-pagination/assets/index.css';
import 'rc-select/assets/index.css';


class MyRequests extends Component {

  componentWillMount() {
    this.props.GetWorkorderList();
  }

  constructor(props) {
    super(props);
    this.state = {
      currentPagination: 1,
      pagination_records_PerPage: 50,
      sortType_in_state: "newest",
      redirect_to_viewMaintenance: false,
      viewMaintenanceID: null,
    
    };
    this.paginatedData = this.paginatedData.bind(this);
    this.sortData = this.sortData.bind(this);
    this.changeSortType = this.changeSortType.bind(this);
    this.filteringRecordsBasedonTenantID = this.filteringRecordsBasedonTenantID.bind(this);
  }

  ViewWorkOrderDetails(WorkOrderID){
    this.setState({ viewMaintenanceID:WorkOrderID, redirect_to_viewMaintenance: true });
  }


  
  render() {
    let { MyRequestsListfromStore,getLabels } = this.props;
    let desktop_records, mobile_records, loader, filteredRecordsBasedonTenantID;
    let pagination_total, indexOfLastTodo, indexOfFirstTodo = 0;
    let paginated_data, sorted_data = [];
    const { currentPagination, pagination_records_PerPage,redirect_to_viewMaintenance,viewMaintenanceID  } = this.state;
    let preferredfields = this.props.getWorkorderPreferences;
    let statusLabel, descriptionLabel, createdbyLabel;

    if (preferredfields !== undefined && preferredfields.length > 0 && !preferredfields.hasOwnProperty('statusText')) {
      preferredfields.forEach(fields => {
        fields.fieldLabel = (fields.fieldLabel !== "" && fields.fieldLabel !== undefined) ? fields.fieldLabel : getLabels['WorkOrderSetup.Options.' + fields.fieldId + '.Text'];
        if (fields.value.length > 0 && fields.fieldId === 1) {
          fields.value.forEach(el => {
            if (fields.fieldId === 1 && el.isCustom === false && el.value === "") {
              el.value = getLabels['WorkOrders.Status.' + el.key + '.Text'];
            }
          });
        }
      });
      statusLabel = preferredfields.filter(x => x.field === "Status" && x.display === true);
      descriptionLabel = preferredfields.filter(x => x.field === "Description" && x.display === true);
      createdbyLabel = preferredfields.filter(x => x.field === "Created" && x.display === true);
    }
    else {
      statusLabel = "";
      descriptionLabel = "";
      createdbyLabel = "";
    } 
    //Redirect to view maintenance page
    if(redirect_to_viewMaintenance){ 
      return   <Redirect to={{ pathname: '/FacilityManagement/ViewMaintenance/MR=' + viewMaintenanceID }}/>
    }


    if (MyRequestsListfromStore !== undefined && !MyRequestsListfromStore.hasOwnProperty('status')) {



      //  Pagination and filtered records 

      if (MyRequestsListfromStore.length !== 0) {

        filteredRecordsBasedonTenantID = this.filteringRecordsBasedonTenantID(MyRequestsListfromStore);
      //  sorted_data = this.sortData(MyRequestsListfromStore);       // Sortingg data, by default its "newest"
        sorted_data = this.sortData(filteredRecordsBasedonTenantID);       // Sortingg data, by default its "newest"
        paginated_data = this.paginatedData(sorted_data);          // pagination data based on sorted data

        indexOfFirstTodo = paginated_data.indexOfFirstTodo;       // pagination record details 
        indexOfLastTodo = paginated_data.indexOfLastTodo;
        pagination_total = paginated_data.pagination_total;

        desktop_records = paginated_data.data.map(el => (         // Desktop Records, returningg records of only sorted and paginated.
          <tr key={el.workOrderID}>
            <td><span onClick={() => { this.ViewWorkOrderDetails(el.workOrderID) }}>{el.serialNumber}</span></td>
            <td>{(el.status > 0)?this.props.getLabels['WorkOrders.Status.' + el.status + '.Text'] :"Not Assigned"}</td>
            <td>{el.description}</td> 
            <td>{new Date(el.createdByDate).toDateString()}</td>
          </tr>));


        mobile_records = sorted_data.map(el => (                 // Mobile Records returning all records from store only sorted but not paginating
          <tr className={styles.mobile_maintable_row} key={el.workOrderID}  onClick={() => { this.ViewWorkOrderDetails(el.workOrderID) }}>
            <td>
              <table border="0" className={styles.mobile_child_table}>
                <tbody>
                  <tr><td>{"RECORD #"}</td><td>{el.serialNumber}</td></tr>
                  <tr><td>{"STATUS"}</td><td>{(el.status > 0)?this.props.getLabels['WorkOrders.Status.' + el.status + '.Text']:"Not Assigned"}</td></tr>
                  <tr><td>{"CREATED"}</td><td>{new Date(el.createdByDate).toDateString()}</td></tr>
                  <tr><td>{"DESCRIPTION"}</td><td>{el.description}</td></tr>
                </tbody>
              </table>
            </td>
          </tr>

        ));
      }
      else {
        desktop_records = <tr><td colSpan="5">{getLabels['NoRecords.Text']}</td></tr>;
        mobile_records = <tr><td colSpan="5">{getLabels['NoRecords.Text']}</td></tr>;
      }
    }
    else {
      loader = <div > <img className="actions_img" src={progressindicator} alt="loader" style={{ marginLeft: '45%' }} /></div>

    }


    return (

      <div>
        {/* Sort section */}

        <div className={styles.sortSection}>
          <label className={styles.sortLabel}>Sort:</label>
          <select ref='filter_in_Select_input' className={styles.sortSelectInput} onChange={this.changeSortType}>
            <option value="newest">Newest</option>
            <option value="oldest" >Oldest</option>
            <option value="closed" >Closed</option>
          </select>
        </div>


        {/* Total records count section */}

        <div className={styles.records_count_section}>
          <p className={styles.records_count_text}>  {indexOfFirstTodo}{" - "}{indexOfLastTodo}{" of"} {pagination_total} {"Maintenance requests shown"} </p>
        </div>


        {/* Desktop Table */}
        <div  className={styles.desktopTableContainer} >
          <Table  className={styles.desktopTable}>
            <tbody>
              <tr><th width="10%">{"RECORD #"}</th><th width="25%">{(statusLabel.length > 0) ? (statusLabel[0].fieldLabel).toUpperCase() : "STATUS"}</th><th width="40%">{(descriptionLabel.length > 0) ? (descriptionLabel[0].fieldLabel).toUpperCase() : "DESCRIPTION"}</th><th width="25%">{(createdbyLabel.length > 0) ? (createdbyLabel[0].fieldLabel).toUpperCase() : "CREATED ON"}</th></tr>
              {desktop_records}
            </tbody>
          </Table>
        </div>
        {loader}

        <Pagination itemRender={textItemRender}
          showTitle={true}
          onChange={this.onChange}
          defaultPageSize={pagination_records_PerPage}
          current={currentPagination}
          total={pagination_total}
          defaultCurrent={6}
          locale={localeInfo}
          style={{ marginRight: '50%' }}
          className={styles.desktopPagination}
        />


        {/* Mobile Table */}
        <Table className={styles.mobiletable}>
          <tbody>
            <tr><th>{"Requests"}</th></tr>
            {mobile_records}
          </tbody>
        </Table>

      </div>
    );
  }


  // Sorting functions
  changeSortType(event) { this.setState({ sortType_in_state: event.target.value }); }

  filteringRecordsBasedonTenantID(MyRequestsListfromStore){
    let employeeTenantID = null;
      if(this.props.employeeTenantDetails !== undefined && this.props.employeeTenantDetails !== null){
          employeeTenantID = this.props.employeeTenantDetails.tenantId;
          return MyRequestsListfromStore.reduce((data, item) => {
            if (item.workOrderDetail['tenantID'] === employeeTenantID) data.push(item);
            return data;
          }, []);
      }
  }


  sortData(MyRequestsListfromStore = []) {
    let { sortType_in_state } = this.state;

    let sortedData = MyRequestsListfromStore.sort(function (a, b) {                 //Sorting data by oldest 
      return +new Date(a.createdByDate) - +new Date(b.createdByDate);
    });
    let sortedDataExcluding_closedStatus = sortedData.filter((element) => element.status !== 6)

    if (sortType_in_state === "newest") {
      sortedDataExcluding_closedStatus.reverse();
      return sortedDataExcluding_closedStatus
    }    //return sorted data by newest 
    else if (sortType_in_state === "closed") {
      let closedWorkOrders = MyRequestsListfromStore.filter((element) => element.status === 6)
      return closedWorkOrders;
    }                                        //return sorted data by Oldest
    else { return sortedDataExcluding_closedStatus }    
  }


  // Pagination functions
  paginatedData(DataFromstore) {
    const { currentPagination, pagination_records_PerPage } = this.state;
    let filtered_data = {
      pagination_total: 0,
      indexOfLastTodo: 0,
      indexOfFirstTodo: 0,
      data: null
    };

    filtered_data.pagination_total = DataFromstore.length;
    filtered_data.indexOfLastTodo = currentPagination * pagination_records_PerPage;
    filtered_data.indexOfFirstTodo = filtered_data.indexOfLastTodo - pagination_records_PerPage;
    if (filtered_data.indexOfLastTodo <= 50) {
      filtered_data.indexOfFirstTodo = 1;
      filtered_data.data = DataFromstore.slice(0, filtered_data.indexOfLastTodo);
    }
    else {
      filtered_data.data = DataFromstore.slice(filtered_data.indexOfFirstTodo, filtered_data.indexOfLastTodo);
    }
    if (filtered_data.pagination_total <= filtered_data.indexOfLastTodo) {filtered_data.indexOfLastTodo = filtered_data.pagination_total }
    return filtered_data;
  }

  onChange = (page) => { this.setState({ currentPagination: page }); }

}

const textItemRender = (current, type, element) => {
  if (type === 'prev') { return 'Previous'; }
  if (type === 'next') { return 'Next'; }
  return element;
};


const mapStateToProps = state => {
  return {
    MyRequestsListfromStore: state.WorkorderRootReducer.WorkOrderList,
    getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
    employeeTenantDetails: state.FacilityRequestsEmployeeTenantDetails.EmployeeTenantDetails,
    getWorkorderPreferences: state.WorkorderRootReducer.WorkOrderStandardFields
  };
};

const mapDispatchToProps = dispatch => {
  return {
    GetWorkorderList: () => dispatch(GetWorkorderList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyRequests);





